var map = {
	"./appointment-icon.svg": 78332,
	"./calendar-clock.svg": 75692,
	"./doctor.svg": 70522,
	"./euro.svg": 11116,
	"./file-circle-euro-solid-primary.svg": 15975,
	"./file-circle-euro-solid.svg": 55194,
	"./hospital-buildings.svg": 45321,
	"./hospital.svg": 51653,
	"./iconappointment.png": 46995,
	"./iconappointment_pr.png": 49910,
	"./iconperform.png": 3511,
	"./iconperform_pr.png": 32122,
	"./icontoday.png": 93127,
	"./icontoday_pr.png": 91978,
	"./iconyesterday.png": 71544,
	"./iconyesterday_pr.png": 10143,
	"./location-icon.png": 67808,
	"./location-icon.svg": 74528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;